var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "submit-tender clearfix",
      staticStyle: { display: "inline-block" },
    },
    [
      _c(
        "div",
        {
          ref: "specifyReasonModal",
          staticClass: "reveal project-reject-modal",
          attrs: { id: _vm.id, "data-reveal": "" },
        },
        [
          _c(
            "div",
            { staticClass: "modal-container" },
            [
              _vm._t("header", function () {
                return [
                  _c("p", { staticClass: "modal-pure-text" }, [
                    _vm._v(_vm._s(_vm.$t("project.docs.rejectAlert"))),
                  ]),
                ]
              }),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rejectReason,
                    expression: "rejectReason",
                  },
                ],
                staticStyle: { color: "#0C3A58" },
                attrs: { type: "text", required: "" },
                domProps: { value: _vm.rejectReason },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.rejectReason = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.apprErrHint
                ? _c(
                    "span",
                    { staticClass: "form-error is-visible appr-error-message" },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.apprErrHint) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("attach-docs", {
            attrs: {
              resourceId: _vm.resourceId,
              btnName: _vm.$t("project.docs.uploadDocs"),
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row align-right nav_btn" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button", "aria-label": "Close reveal" },
                on: {
                  click: function ($event) {
                    return _vm.specifyReasonModal.close()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.reject()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.reject")))]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }